module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: [
      'btn',
      _vm.icon ? 'btn--' + (_vm.negative ? 'negative' : 'positive') : '',
      'btn--' + (_vm.button || 'secondary'),
      'btn--' + (_vm.size || 'm'),
      {
        'btn--icon': _vm.icon,
        'btn--idle': (!_vm.hover && !_vm.isHover && !_vm.active && !_vm.isActive) || (_vm.loading),
        'btn--hover': (_vm.hover || _vm.isHover || _vm.active || _vm.isActive) && !_vm.disabled && !_vm.loading,
        'btn--active': (_vm.active || _vm.isActive) && !_vm.disabled && !_vm.hover && !_vm.loading,
        'btn--disabled': !_vm.success && !_vm.loading && _vm.disabled,
        'btn--loading': _vm.loading,
        'btn--success': _vm.success,
        'btn--dark': _vm.dark,
      }
    ],
    attrs: {
      "disabled": _vm.disabled || _vm.loading || _vm.success
    },
    on: {
      "mouseover": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onMouseDown($event)
      },
      "click": _vm.onClick
    },
    nativeOn: {
      "mouseover": function($event) {
        _vm.onMouseEnter($event)
      },
      "mouseleave": function($event) {
        _vm.onMouseLeave($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onMouseDown($event)
      }
    }
  }, 'component', _vm.linkProps, false), [_c('b', {
    staticClass: "btn__bg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('module-spinner', {
    class: "btn__spinner",
    attrs: {
      "active": _vm.loading
    }
  }), _vm._v(" "), _c('module-icon', {
    class: "btn__success",
    attrs: {
      "icon": "tick"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn__inner"
  }, [_c('span', {
    staticClass: "btn__content"
  }, [_c('span', {
    staticClass: "btn__label"
  }, [(_vm.label) ? [_vm._v(_vm._s(_vm.label))] : _vm._t("default")], 2), (_vm.icon) ? _c('module-icon', {
    class: "btn__icon",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7298420e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Button.vue
// module id = 85
// module chunks = 3